const slides = [
  {
    "title" : "Testimonials",
    "imgSrc" : "../../public/images/landing/ic_profile placeholder.png",
    "content" : "Airwaybill is really easy to use when I buy my vitamins from the US. I know the trip will be made on a specific date, and who is my carrier. No constant refreshing 'track status' button. No fee haggling. I won't bother with asking someone on twitter anymore.",
    "subtitle" : "J. YI"
  },
   {
    "title" : "Testimonials",
    "imgSrc" : "../../public/images/landing/ic_profile placeholder.png",
    "content" : " I can bring a couple of Smartphones back home to Delhi and make a little more than hundred dollars – probably the easiest hundred dollars I will ever make.",
    "subtitle" : "A. Gupta"
  },
   {
    "title" : "Testimonials",
    "imgSrc" : "../../public/images/landing/ic_profile placeholder.png",
    "content" : " I was getting tired of all the 'out of stock' items on international shopping website. Nothing is out of stock on Airwaybill – there is always a place that sells exactly the item I want. ",
    "subtitle" : "A. Cam"
  }
];

const  shipper =
    {
        "shipperObjPost" : {
        	shipPackage: 'SHIP A PACKAGE',
        	shipperTextHeader: 'Post a Shipment',
        	shipperTextDetails: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts away',
          imageUrl: '../../public/images/landing/tab_component/post_a_shipment.png'
        },

        "flyerObjGet" : {
        	carryPackage: 'CARRY A PACKAGE',
        	flyerTextHeader: 'Ready anywhere, anytime.',
        	flyerTextDetails: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts away',
          imageUrl: '../../public/images/landing/tab_component/post_a_shipment.png'
        },

        "shipperObjShip": {
        	shipPackage: 'SHIP A PACKAGE',
        	shipperTextHeader: 'Track Your Package',
        	shipperTextDetails: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts away',
          imageUrl: '../../public/images/landing/tab_component/ready_anywhere.png'
        },

        "flyerObjTrack":{
        	carryPackage: 'CARRY A PACKAGE',
        	flyerTextHeader: 'Ready anywhere, anytime.',
        	flyerTextDetails: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts away',
          imageUrl: '../../public/images/landing/tab_component/ready_anywhere.png'
        },

        "shipperObjDeliver":{
        	shipPackage: 'SHIP A PACKAGE',
        	shipperTextHeader: 'Ready anywhere, anytime.',
        	shipperTextDetails: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts away',
          imageUrl: '../../public/images/landing/tab_component/track_your_package.png'
        },

        "flyerObjReview": {
        	carryPackage: 'CARRY A PACKAGE',
        	flyerTextHeader: 'Ready anywhere, anytime.',
        	flyerTextDetails: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts away',
          imageUrl: '../../public/images/landing/tab_component/track_your_package.png'
        }
    };

const shipperDetails = {
  lila : "../../public/images/account/img2.png",
  manisha : "../../public/images/account/img1.png",
  lilaMom : "../../public/images/account/img3.png",
  dina : "../../public/images/account/dina.png",
  karim : "../../public/images/account/karim.png",
  husb : "../../public/images/account/husb.png",
  heading : "AirWayBill is an application that allows you to meet carriers, shippers and international shoppers around the world. Connect, message, ship and pay all in one platform. ",
  para1 : "Lila lives in the US and wants to ship vitamins worth $15 to India for her mom. She prepares the item (unsealed), takes a photo and posts on AirWayBill. Fee is minimum $20, or 10% of the item value. Since Lila’s mom can meet the carrier at the airport and bottles are fairly small, Lila decides to offer just $30. ",
  para2 : "Manisha is an Indian student studying in the University near Lila’s house. Manisha has a plan to visit home in Delhi for spring break. She checks for packages to carry nearby on AirWayBill, accepts Lila’s offer and provides her travel detail and credit card information to insure the package. She is also aware of the fact that she doesn’t have to declare such low value item. ",
  para3 : "Lila sees that Manisha accepted her offer and sends a message to arrange pick up. Lila and Manisha meet at her school the next day for package hand off. ",
  para4 : "Manisha packs the bottles and gets on board. ",
  para5 : "13 hours later, Manisha messages Lila’s mom through AirWayBill platform to meet at the arrival terminal and delivers the item. Manisha receives delivery fee of $24 to her Paypal account, which is total fee minus AirWayBill fee of $4 (20%). ",
  para6 : "Dina is a young trend setter living in Jeddah. She learns about a perfume brand only available in New York and San Francisco, and wants to try their Ylang fragrance. ",
  para7 : "The website says that the retail price is $300, including tax. Dina requests the item on AirWayBill, and provides her credit card information and store location for purchase. Considering carrier’s effort to make a trip to the store, Dina puts $100 as a carriage fee. ",
  para8 : "Karim, pharmaceutical representative living in Riyadh, travels between Jeddah, New York and Riyadh all the time. He sees Dina’s request and realizes that the perfume store is a block away from his hotel in SoHo. He accepts the offer and arranges delivery with Dina. As they confirm the transaction Dina’s credit card gets charged for the item price and the delivery ($400). Her husband will meet Karim at Red Sea Mall back in Jeddah. ",
  para9 : "Karim makes a quick trip to the store to buy the item. He takes a picture of the receipt and sends to Dina to confirm the price, packs it up brings it back to Jeddah with him. ",
  para10: "Karim meets Dina’s husband and makes the delivery. He earns $80 for the shopping service he provided, and receives $300 he paid for the perfume as well. He just made enough to fly from Jeddah and Riyadh to see his family! "
}

const ShippingRoleData = {
    "shipper":{
      "title":"Ship a Package",
      "imageUrl": '../../public/images/landing/ship_a_package.png',
      "imageUrlResponsive": "../../public/images/landing/ship_a_package_responsive.png",
      "roles":[
         {
           "role": "POST A SHIPMENT",
           "info": "Upload a photo of the item you want to ship, from anywhere in the world. When someone sees your post they can offer to bring it to you for as little as 10% of the item value."
         },
         {
           "role": "TRACK YOUR PACKAGE",
           "info": "Once someone offers to carry the item you want, you can start chatting with your carrier to arrange pick up location, travel date and delivery location."
         },
         {
           "role": "GET YOUR ITEM",
           "info": "Meet the carrier and receive the item you requested. Confirm delivery and payment. That’s it! No more steps. Enjoy your day!"
         }
       ]
    },
    "carrier":{
      "title":"Carry a Package",
      "imageUrl": '../../public/images/landing/carry_a_package.png',
      "imageUrlResponsive": '../../public/images/landing/carry_a_package_responsive.png',
      "roles":[
         {
           "role": "SELECT ITEMS TO CARRY",
           "info": "Open the application and search for items to carry on your trip. You’ll also see ‘requested items’, which means that you can offer to buy something from the store and carry it. Filter and select based on your destination, item size and value. Pro-tip: Check if the item meets custom requirement of your destination"
         },
         {
           "role": "ARRANGE PICK-UP",
           "info": "You can now message the shipper or requester to arrange pick up and delivery. Share your itinerary and discuss delivery options. Whatever works for you and the shipper, works for AWB."
         },
         {
           "role": "DELIVER AND GET PAID",
           "info": "Time to pack it up and travel! Meet your receiver and confirm the delivery. Your travel may just have paid for itself!"
         }
       ]
    },
    "receiver":{
      "title":"Request an Item",
      "imageUrl": '../../public/images/landing/request_an_item.png',
      "imageUrlResponsive": '../../public/images/landing/request_an_item_responsive.png',
      "roles":[
         {
           "role": "START YOUR SHOPPING",
           "info": "Ordering something from abroad? Look for the store abroad that carries the item you want. Post your request with a bounty. When someone sees your request they can offer to buy it from the store and bring it to you."
         },
         {
           "role": "TRACK YOUR PACKAGE",
           "info": "Once someone offers to buy the item you want, you can start chatting with your carrier about where to buy and when to receive it."
         },
         {
           "role": "GET YOUR ITEM",
           "info": "Meet your carrier and receive the item you requested. Confirm delivery and payment. That’s it! No more steps. Enjoy your day!"
         }
       ]
    }
};

module.exports = {
  slides,
  shipper,
  ShippingRoleData,
  shipperDetails
}



// WEBPACK FOOTER //
// app/landing/landing_data.jsx